var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _rect6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHealthPilatesServiceBody2Mobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 131,
    viewBox: "0 0 101 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.728798,
    y: 0.744423,
    width: 99.2414,
    height: 129.387,
    rx: 2.01174,
    fill: "#F3F3F3",
    stroke: "#EDEDED",
    strokeWidth: 0.574784
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7852,
    y: 69.5225,
    width: 63.1256,
    height: 4.20837,
    rx: 2.10419,
    fill: "#CACACA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7852,
    y: 82.3535,
    width: 63.1256,
    height: 4.20837,
    rx: 2.10419,
    fill: "#CACACA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7852,
    y: 95.1846,
    width: 63.1256,
    height: 4.20837,
    rx: 2.10419,
    fill: "#CACACA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7852,
    y: 108.014,
    width: 44.8893,
    height: 4.20837,
    rx: 2.10419,
    fill: "#CACACA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5815 12.6387L50.4452 7.3916L38.12 12.6387V18.7231C38.12 22.2398 37.8174 25.9239 42.0395 31.506C44.2686 34.4531 48.572 36.2321 50.4452 36.7531C51.8619 36.567 55.4886 35.2571 58.662 31.506C62.5815 26.8729 62.5972 21.4211 62.5815 18.7231V12.6387Z",
    fill: "#3A7EFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1836 22.6162L48.446 26.4224L55.5145 17.7227",
    stroke: "white",
    strokeWidth: 1.14957,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5059,
    y: 44.7012,
    width: 53.6876,
    height: 16.8733,
    fill: "url(#pattern0_2141_168)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2141_168",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2141_168",
    transform: "matrix(0.00357143 0 0 0.0113636 -0.00178571 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2141_168",
    width: 281,
    height: 88,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARkAAABYCAYAAADBY4NqAAAACXBIWXMAAAsSAAALEgHS3X78AAAFgklEQVR4nO3d8XHbNhTHcbye/482qDeoN4gyQZsNvEG8QewJ6hGcDbJB5A2kDegNrAmQgwOoKENKtIRHgMD3c+ezzpfYpEj9AILggxhjbowxjyatJ2vt03t/o4jMvi0i8ujfg2SstevE+1CMhO/X6HFJeR7UfCw0aHwerowxK2PMx8Tbuznz/+XYlhuFvzmZiKxSH9TEttba1+hXpnq/jh0XjfPgqAUch0t01tpu4v9P/nm4SrorOIc7qD8Kfuc+XdBoLEnpx+ESD8aY+1x//I9cfxhAGwgZAKoIGQCqigmZygfegGbNMvArIuE24rX/csLPXLB84BQE6qQVMrcicmuM+ZPzBmibVsgQLgDeMPALQBUhA0BVUzN+owHoeNCZO1qAohZC5k5EvhawHUCTWrhc4vY4kBFjMgBUETIAVBEyAFRRT6YeL644kcLevE74N8AoQqYerpxltsJEFXBh+lzAbrgHhf8qYDuSIWSAX7WAt9H8qWz8XK6qKvQxJgNAVSk9mTCeUF1XEWiddsjsXbV7/3rrr3tf45/FlfBr7CoCrdMKmQcGIQEYxmQAaCNkAKjiFjaKERWTp/xGRQgZ5LIWkbAy5TUlW+s1e8gMrFwQL4VCC9aObOuPY15aIeNaqftoBiUtFdAorZD5SEsFDOstZBi/vq6xN8+YDJCAiMQLF9748Oi/brLhbSFkwiMLYcZxF76stZ0ffKTXhd9E44cmuvTv90J4DOaEFkKGEgg4SURccDyybHJ6XC4Bv6zo0epgxi8AVYQMAFWEDABVhAwAVYQMAFXcXUpHa0kSYNEImdOGSoiGCX2uyv3mgt8NVK/2kHme0LvYTqk/DOA8Sw2Z+NIk9CQOQeHX0JnEWns39d/2HmwLz6T0f/bBWivJ9hRYuBJDJqzi91vvQvPSZKDOjaFUBXC5OUNmN3BJEkLj7WHFHMeTByQBXSlCZj8UGgyMArM4tbZZtgY8OBUy4dKlGxoDYWAUCQw1Um6c60vjb27o+ZulN95XfqMfzh04nWJgvOMpd7oiu9EFAP35UmvIDDXcap+9Elz5D/tZ9VZ8DY6hOyyrE4Olm7knro1s65ri5VD0zTWoJVyy5HRyTMa3KuveLdtiqoH1yh6GHlOR24rmuHBpfkxyysCv++B+nWFb/mdkTkocKNwRAhYg1zyZG5G3+Wpjay9R/hCoRK6Q+ZcTCGgDpR4AqCJkAKgiZACoImQAqKJoFU6KZmyvoykEqIw/zqvUe0XIoB8i8XfmIlUgdxkTQqZy0aTG/ndDiCzbUmogETL1cBMc73thwiMVC1RbATVCph5/+y8UqtXqiy2FzFhtnEdafCi5FZHb1ku31hAyQ2U9D0uXnHrEXkQovAUtzdeFNoWHzNCKBKEXUmVxH6BGuUJmF/U8ZluRIOiVkUg+LwDAf3KFzF3qMIkG1Uw0mBa/5m4LkEGxl0tRuUwT3ZIdek3tGaBguULmn5HbeSyiBlQmV8i0vtwF0AyewgagipABoIqQAaCKkAGgipABoIqQAaCKUg9AW/bRg8Rh1v3hgWK/dnfSYmaEDMb0ny8LD6dSGqNsoaRJ/7hNeqjYr+yaFCHTpqHW7NCqWWtHy19QGiOrseAvuioBIVOnl+gE7OITkxIZxdr1g2POygSaCJll6neJD9+P9UKQzUs/7GsJkCkImfLsh8LDLP+E3Pn92PowrOXD1Q8QM/XSsxWETH7uxPw0pVTogpQQKLvoQ3+uo3diKjpeKYXQ3YTjT8hk5ls6eiiXeY62oTtzG9wH4zMB8i4v0fu+Geu5TQmZ6q8Z8S5uHsX3TIGyj07ozm9DkoFsHyoEy7jQmHTHAmWIWGvL2AXA8wXNvsctpD+pCQFlIuLeb1d5Mk3v1BjzE/u0+WeYjh40AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHealthPilatesServiceBody2Mobile);
export default __webpack_public_path__ + "static/media/IcHealthPilatesServiceBody2Mobile.77d23ee3b2e1ac51addd130577c8f677.svg";
export { ForwardRef as ReactComponent };